module.exports = __webpack_public_path__ + "fonts/Calibre-BlackItalic.662853ef.woff";